import { getWWRedirectUrl } from "utils/helper";
import { trackFormError } from "./trackEvent";

type PAGEVIEW_EVENT_DATA = { page_url: string };

type CTA_CLICK_EVENT_DATA = {
  current_url: string;
  cta_name: string;
  next_url: string;
};

type HEALTH_APP_STAGES_DATA = {
  health_app_step?: number | null;
  health_app_status?: string;
  app_name?: string;
  version?: number | null;
};

type CustomerIOEventJSON = {
  event_name: string;
  event_type: string;
  member_uuid: string;
  data: PAGEVIEW_EVENT_DATA | CTA_CLICK_EVENT_DATA | HEALTH_APP_STAGES_DATA;
};

export const sendCustomerIOEvent = (
  eventData: CustomerIOEventJSON,
  accessToken: string
) => {
  if (!accessToken) {
    return;
  }
  const customerioURL = getWWRedirectUrl("/customerio/event");
  fetch(customerioURL, {
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + accessToken,
    },
    body: JSON.stringify(eventData),
  }).catch((error) => {
    trackFormError(error, "Error sending data to customerio");
  });
};
